module.exports = __webpack_public_path__ + "17442e199a0b08979ca4c4f4349517db.png";